import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"c-loading__inner -search\"><div class=\"c-loading\"><svg class=\"c-loading__svg\" width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><g><path class=\"c-loading__letters\" d=\"M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4\"></path><path class=\"c-loading__letters\" d=\"M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6\n                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3\n                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3\"></path></g><circle class=\"c-loading__circle\" cx=\"50\" cy=\"50\" r=\"40\" stroke=\"url(#gradient)\" stroke-width=\"5\" fill=\"none\"></circle><defs><linearGradient id=\"gradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\"><stop offset=\"0%\" style=\"stop-color:#E40032;stop-opacity:1;\"></stop><stop offset=\"100%\" style=\"stop-color:#ffffff;stop-opacity:1;\"></stop></linearGradient></defs><g><path class=\"c-loading__letters\" d=\"M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z\"></path><path class=\"c-loading__letters\" d=\"M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2\n                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3\"></path><path class=\"c-loading__letters\" d=\"M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2\n                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z\"></path><path class=\"c-loading__letters\" d=\"M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4\n                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5\n                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4\n                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z\n                                    \"></path></g></svg></div></div>", 1)
const _hoisted_3 = { class: "o-form__item__container" }
const _hoisted_4 = { class: "o-form__item" }
const _hoisted_5 = {
  class: "o-label sr-only",
  for: "programmes-search"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "o-form__item" }
const _hoisted_9 = {
  class: "o-label sr-only",
  for: "programme-project"
}
const _hoisted_10 = { value: "" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "o-form__item" }
const _hoisted_14 = {
  class: "o-label sr-only",
  for: "domaine-de-recherche"
}
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_18 = { class: "o-form__button c-tooltip__wrap" }
const _hoisted_19 = {
  class: "o-button -button-bg",
  type: "submit"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_21 = { class: "o-button__text" }
const _hoisted_22 = { class: "o-button__text__elm" }
const _hoisted_23 = { class: "sr-only" }
const _hoisted_24 = { class: "c-tooltip" }
const _hoisted_25 = { class: "c-tooltip__text" }
const _hoisted_26 = { class: "o-container" }
const _hoisted_27 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_28 = { class: "c-programmes-search__filters__total" }
const _hoisted_29 = {
  key: 0,
  class: "c-programmes-search__filters__actives"
}
const _hoisted_30 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_34 = { class: "sr-only" }
const _hoisted_35 = { class: "c-programmes-search__filters__reset" }
const _hoisted_36 = { class: "o-container" }
const _hoisted_37 = {
  ref: "resultsStart",
  class: "c-projects-search__results"
}
const _hoisted_38 = { class: "c-search-results__item -show" }
const _hoisted_39 = { class: "c-search-result__header" }
const _hoisted_40 = { class: "c-search-result__title o-title-4" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "c-search-result__desc" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  key: 0,
  class: "c-search-result__tags"
}
const _hoisted_45 = { class: "o-tag" }
const _hoisted_46 = { class: "o-tag" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pager = _resolveComponent("Pager")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-programmes-search", [$props.background]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["o-form -form-preload", {'-loading': $data.loading}])
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                class: "o-input",
                id: "programmes-search",
                type: "text",
                placeholder: $options.t("Mots clés"),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchInput) = $event))
              }, null, 8 /* PROPS */, _hoisted_6), [
                [_vModelText, $data.searchInput]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString($options.t("Programme d'études visé")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[1] || (_cache[1] = $event => ($options.changeSelectionProgramme())),
                class: "o-select",
                id: "programme-project",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.selectedProgramme) = $event))
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString($options.t("Programme d'études visé")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.programmes, (programme) => {
                  return (_openBlock(), _createElementBlock("option", { value: programme }, _toDisplayString(programme.label), 9 /* TEXT, PROPS */, _hoisted_11))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedProgramme]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString($options.t("Domaines de recherche")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                onChange: _cache[3] || (_cache[3] = $event => ($options.changeSelectionDomaine())),
                class: "o-select",
                id: "domaine-de-recherche",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedDomaine) = $event))
              }, [
                _createElementVNode("option", _hoisted_15, _toDisplayString($options.t("Domaines de recherche")), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.domaines, (domaine) => {
                  return (_openBlock(), _createElementBlock("option", { value: domaine }, _toDisplayString(domaine.label), 9 /* TEXT, PROPS */, _hoisted_16))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, $data.selectedDomaine]
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString($options.t("Rechercher")) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_23, _toDisplayString($options.t("un projet selon les critères sélectionnés")), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
              ])
            ])
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" <pre>{{ selectedProgrammes }}</pre>\n<pre>{{ selectedDomaines }}</pre> "),
    _createElementVNode("div", {
      class: _normalizeClass(["c-programmes-search__filters", {'-loading': $data.loading}])
    }, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", null, _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
          ]),
          ($options.tags.length && !$data.loadingAttributes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("span", null, _toDisplayString(tag.obj.label), 1 /* TEXT */),
                    _createElementVNode("button", {
                      onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                      class: "c-programmes-search__filters__remove"
                    }, [
                      _hoisted_32,
                      _hoisted_33,
                      _createElementVNode("span", _hoisted_34, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.obj.label), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_31)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($options.resetSearch()), ["prevent"])),
              class: "o-button -button-reset"
            }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
          ])
        ])
      ])
    ], 2 /* CLASS */),
    (!_ctx.target)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["o-section__inner", {'-loading': $data.loading}])
        }, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredResultsPaged, (entry) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, [
                      _createElementVNode("a", {
                        href: entry.url
                      }, _toDisplayString(entry.title), 9 /* TEXT, PROPS */, _hoisted_41)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("p", {
                      innerHTML: entry.description
                    }, null, 8 /* PROPS */, _hoisted_43)
                  ]),
                  (entry.programmes.length || entry.domaines.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.programmes, (programme) => {
                          return (_openBlock(), _createElementBlock("span", _hoisted_45, [
                            programme
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(programme.label.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.domaines, (domaine) => {
                          return (_openBlock(), _createElementBlock("span", _hoisted_46, [
                            domaine
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(domaine.label.replace(/<[^>]*>?/gm, '')), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */),
            ($data.pagerInfo.totalPages > 1 && $options.filteredResults.length > 0)
              ? (_openBlock(), _createBlock(_component_Pager, {
                  key: 0,
                  pagerInfo: $data.pagerInfo,
                  onGoToPage: $options.goToPage
                }, null, 8 /* PROPS */, ["pagerInfo", "onGoToPage"]))
              : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}